import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Exam|Badge|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareCertMetricsBadging,
	portal: 'SP',
};

type LocNameStart = 'SPExamCatalogBadge';
export type SPExamCatalogBadgeLocNames = `${LocNameStart}TitleSection` | `${LocNameStart}TitleTab`;

export const spExamCatalogBadgeLocs: LocDefs<SPExamCatalogBadgeLocNames> = {
	SPExamCatalogBadgeTitleSection: {
		defaultValue: 'Certmetrics Badge',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Share.CertmetricsBadging/Catalogs.Exams.CMBadge.Title.Section',
		...sharedProperties,
	},
	SPExamCatalogBadgeTitleTab: {
		defaultValue: 'Certmetrics Badging',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Share.CertmetricsBadging/Catalogs.Exams.CMBadge.Title.Tab',
		...sharedProperties,
	},
};

export type SPExamCatalogBadgeLocType = LocMap<SPExamCatalogBadgeLocNames>;
